const fileNamePattern = /^glossary_.+\.csv$/;

export const defaultGlossaryName = (fileName: string): string => {
    if (fileNamePattern.test(fileName)) {
        return fileName.slice(9, fileName.length - 4);
    }

    const dotIndex = fileName.lastIndexOf(".");

    if (dotIndex === -1) {
        return fileName;
    }

    return fileName.substring(0, dotIndex);
};
